



















import { Component, Vue, Prop } from 'vue-property-decorator';
@Component({
  components: {}
})
export default class TypeBox extends Vue {
  @Prop() type!: string;
  @Prop() classIcon!: string;
  @Prop() isSendOffer!: boolean;
  @Prop() isAward!: boolean;

  private emitClick(type: string) {
    this.$emit('click', type);
  }
}
